import { TTeamMember } from 'modules/api/user/types'
import { TPortfolioSummary } from 'modules/api/portfolio/types'
import { SearchResult } from 'components/molecules/Search/Search'
import { TSegmentPortfolioRow, TSegmentTeamRow } from '../../types'

const fullName = (member: TTeamMember): string => `${member.firstName ?? ''} ${member.lastName ?? ''}`.trim()

export const transformTeamMemberForSearch = (member: TTeamMember): SearchResult => ({
  id: member.userId,
  text: fullName(member),
  secondaryText: member.emailAddress,
})

export const transformPortfolioSummaryForSearch = (summary: TPortfolioSummary): SearchResult => ({
  id: summary.portfolioId,
  text: summary.mainText,
  secondaryText: summary.secondaryText,
})

export const transformTeamMemberForTable = (member: TTeamMember): TSegmentTeamRow => ({
  id: member.userId,
  name: fullName(member),
  lastLoggedIn: member.lastLoggedIn,
  email: member.emailAddress,
})

export const transformPortfolioFormTable = (summary: TPortfolioSummary): TSegmentPortfolioRow => ({
  id: summary.portfolioId,
  propertyAddress: {
    mainText: summary.mainText,
    secondaryText: summary.secondaryText,
  },
  leaseDetails: {
    term: summary.leaseTerms ? `${summary.leaseTerms.startDate} -> ${summary.leaseTerms.endDate}` : '-',
  },
})
